<script>
import { Row, Col, Icon, Empty, Dialog } from 'vant'
import draggable from 'vuedraggable'
import CheckboxListPopup from '@/components/org/CheckboxListPopup'
import BottomToolbar from '@/components/org/BottomToolbar'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-group-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-row': Row,
        'van-col': Col,
        'van-icon': Icon,
        'van-empty': Empty,
        'draggable': draggable,
        'checkbox-list-popup': CheckboxListPopup,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            group: {
                matchId: null,
                matchGroupId: null,
                stageId: null,
                groupId: null,
                groupTeamTotal: null,
                teamList: [],
                unassignedTeamList: [],
            },
            isEdit: null,
            showPopup: null,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        countTeamNum() {
            let teamCount = '0'
            if (this.group.teamList && this.group.teamList.length) {
                teamCount = this.group.teamList.length.toString()
            }
            if (this.locale.localeProp) {
                return this.locale.localeProp('team-count-num', {num: teamCount})
            }
            return ''
        },
        totalTeamNum() {
            if (this.locale.localeProp) {
                return this.locale.localeProp('team-total-num', {num: this.group.groupTeamTotal})
            }
            return ''
        },
        availTeamNum() {
            if (this.group.groupTeamTotal) {
                return this.group.groupTeamTotal - this.group.teamList.length
            }
            return 0
        },
        operatorIconButtons() {
            return [
                { type: 'reset-group', iconType: 'vant', icon: 'replay', label: this.locale['reset'] },
                { type: 'import-team', iconType: 'vant', icon: 'certificate', label: this.locale['import'] },
            ]
        },
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onEnd() {
            console.log('onEnd', JSON.stringify(this.group.teamList))
            this.submitData()
        },
        onTeamItemClick(item) {
            console.log('onTeamItemClick', item)
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgManageTeam',
                    params: {
                        id: item.id
                    },
                    query: {
                        matchGroupId: this.group.matchGroupId,
                        matchId: this.group.matchId
                    }
                }
            })
        },
        onShiftBtnClick(item) {
            console.log('onShiftBtnClick', JSON.stringify(item))
            Dialog.confirm({
                title: this.locale['shift-team'],
                message: this.locale['shift-team-confirm-message']
            }).then(() => {
                // on confirm
                for (let i = 0; i < this.group.teamList.length; i++) {
                    let team = this.group.teamList[i]
                    if (team.id == item.id) {
                        this.group.unassignedTeamList.push(team)
                        this.group.teamList.splice(i, 1)
                        break;
                    }
                }
                this.submitData()
            }).catch(() => {
                // on cancel
            })
        },
        onBottomToolbarIconClick(type) {
            if (type == 'reset-group') {
                this.onResetBtnClick()
            }
            else if (type == 'import-team') {
                this.onImportBtnClick()
            }
        },
        onResetBtnClick() {
            console.log('onResetBtnClick')
            Dialog.confirm({
                title: this.locale['reset-group'],
                message: this.locale['reset-group-confirm-message']
            }).then(() => {
                // on confirm
                this.group.unassignedTeamList.concat(this.group.teamList)
                this.group.teamList = []
                this.submitData()
            }).catch(() => {
                // on cancel
            })
        },
        onImportBtnClick() {
            console.log('onImportBtnClick')
            this.showPopup = true
        },
        onTeamImportDataChange(data) {
            console.log('onTeamImportDataChange', data)
            for (let i = 0; i < data.length; i++) {
                let teamId = data[i]
                for (let j = this.group.unassignedTeamList.length - 1; j >= 0; j--) {
                    let unassignedTeam = this.group.unassignedTeamList[j]
                    if (unassignedTeam.id == teamId) {
                        this.group.teamList.push(unassignedTeam)
                        this.group.unassignedTeamList.splice(j, 1)
                        break
                    }
                }
            }
            if (data.length > 0) {
                this.submitData()
            }
            this.showPopup = false
        },
        onSaveBtnClick() {
            this.submitData('save')
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        submitData(type) {
            console.log('submitData')
            type = type || 'submit'
            const teamList = this.group.teamList.map(item => (item.id))
            if (teamList.length > 0) {
                while (teamList.length < this.group.groupTeamTotal) {
                    teamList.push('')
                }
            }
            this.$emit('custom-event', {
                type: type,
                data: {
                    matchGroupId: this.group.matchGroupId,
                    stageId: this.group.stageId,
                    groupId: this.group.groupId,
                    teamList: teamList
                }
            })
        },
    },
}
</script>

<template>
    <div class="group-edit">
        <div class="nav-op-bar fixed-top">
            <van-row class="hp100 vertical-center">
                <van-col 
                    class="main-text primary-color text-right u-inner-padding" 
                    span="24"
                    @click="onSaveBtnClick">
                    {{ locale['confirm'] }}
                </van-col>
            </van-row>
        </div>
        <div v-if="group.teamList.length > 0" class="team-list-wrapper">
            <div class="text-right u-outer-padding">
                <span class="normal-text minor-color">{{ locale['group-team-drag-hint'] }}</span>
            </div>
            <van-row class="team-list">
                <van-col class="static-seq inline-block" span="3">
                    <div 
                        v-for="seq in group.teamList.length" 
                        :key="seq" 
                        class="unit bg-white justify-center vertical-center"
                    >
                        <span class="main-secondary-color">{{seq}}</span>
                    </div>
                </van-col>
                <van-col class="team-seq inline-block" span="21">
                    <draggable v-model="group.teamList" @end="onEnd">
                        <div 
                            v-for="item in group.teamList" 
                            :key="item.id" 
                            class="unit bg-white vertical-center relative"
                            @click="onTeamItemClick(item)"
                        >
                            <div class="vertical-center">
                                <div class="inline-block l-outer-margin">
                                    <van-icon name="wap-nav" color="#969799"/>
                                </div>
                                <div class="inline-block l-outer-margin">
                                    <img v-if="item.logoUrl" style="width: 55px; height: 55px;" :src="adjustImageSize(item.logoUrl, 110, 110)"/>
                                    <img v-else
                                        src="@/assets/org/logo-symbol.png"
                                        style="width: 55px; height: 55px;"
                                    />
                                </div>
                                <div class="inline-block l-outer-margin">
                                    <span class="team-name text-title main-color van-ellipsis block">{{ item.label }}</span>
                                </div>
                                <div class="shift-btn" @click.stop="onShiftBtnClick(item)">
                                    <span class="normal-text primary-color">{{ locale.shift }}</span>
                                </div>
                            </div>
                            <div class="separator-line-bottom" style="left: 0;"/>
                        </div>
                    </draggable>
                </van-col>
            </van-row>
        </div>
        <div v-else @click="onImportBtnClick">
            <van-empty 
                :description="locale['group-team-empty-hint']"
                image="search"
            />
        </div>
        <bottom-toolbar
            type="rate-icons"
            :minorRateCountLabel="countTeamNum"
            :minorRateTotalLabel="totalTeamNum"
            :mainIcons="operatorIconButtons"
            @click-main-icon="onBottomToolbarIconClick"
        />
        <checkbox-list-popup
            :show="showPopup"
            :title="locale['unassigned-group-team']"
            :list="group.unassignedTeamList"
            :max="availTeamNum"
            @change-data="onTeamImportDataChange"
        />
    </div>
</template>

<style scoped>
.group-edit {
    overflow-x: hidden;
}
.team-list .sortable-drag {
    box-shadow: 0px 6px 10px 3px rgba(0, 0, 0, 0.05);
}
.team-list .sortable-ghost {
    opacity: 0.2;
}
.team-list .unit {
    height: 96px;
}
.shift-btn {
    position: absolute;
    right: 16px;
}
.team-name {
    max-width: 180px;
}
</style>